/* eslint-disable */
import * as React from 'react';
import { FunctionComponent } from 'react';

const Controls: FunctionComponent<any> = (props) => <>{props.children}</>;

export default Controls;
